import { useState, useEffect } from 'react';
import useDataBean from '../../../../core/services/dataBean/useDataBean';
import { _CargoManifest } from '../../../../core/services/dataBean/EntityCatalog';
import usePaginator from '../../../theme/Component/usePaginator';
import useModal, { MODAL_LG } from '../../../theme/Component/hooks/useModal';
import { toast } from 'react-toastify';
import { Modal } from '../../../theme/Component/Modal';
import { BasicButton } from '../../../theme/Component/BasicButton';
import { BasicTable } from '../../../theme/Component/BasicTable';
import { SelectCargoManifest } from './SelectCargoManifest';
import { TransportDestinationEditor } from '../TransportDestination/TransportDestinationEditor';



interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
    returnType?: "ID" | "Object";
    render?: string;
}

type formFilter = {
    State: number;
    IDTransportDestinationOrigin: number;
    IDTransportDestinationDestinity: number;
    regexStr: string;
}

export const EditorCargoManifest = ({ idSelector, onChange, label, returnType = "ID", render }: Props) => {

    const { instance, bean, setBean, lista, setLista } = useDataBean(_CargoManifest);
    const paginador = usePaginator();

    const [id, setID] = useState(null);
    const [text, setText] = useState<string>("")
    const [filter, setFilter] = useState<Partial<formFilter>>({})

    const modal = useModal("Cargos de Manifiesto", MODAL_LG);

    useEffect(() => {
        setID(idSelector)
    }, [idSelector])

    useEffect(() => {
        if (render) {
            setText(render)
        }
    }, [render])

    useEffect(() => {
        getLista();
    }, [paginador.page])


    const setValue = (e: string) => {
        const selectedId = parseInt(e);
        setID(selectedId);
        if (onChange) {
            const selectedItem = lista.find(
                (item) => item?.DataBeanProperties?.IDCargoManifest == e
            );
            if (selectedItem) {
                onChange(returnType === "Object" ? selectedItem?.DataBeanProperties : selectedId);
                modal.close();
                if (selectedItem.DataBeanProperties.IDCargoManifest) {
                    setText(selectedItem.DataBeanProperties.Name)
                }
            } else {
                onChange(returnType === "Object" ? {} : null);
            }
        }
    };

    useEffect(() => {
        getLista();
    }, [paginador.page])

    const getLista = () => {
        instance.getCargoManifestCatalog(filter.State, filter.IDTransportDestinationOrigin, filter.IDTransportDestinationDestinity, filter.regexStr, paginador.page, 15).then(
            (resp: any) => {
                paginador.setPages(resp.NumberOfPages);
                paginador.setRecords(resp.NumberOfPages * (15));
                paginador.setRegiPerPage(15)
                setLista(resp.List);
            }
        ).catch(err => {
            toast.error("Error al cargar la lista de Manifiestos de Carga");
        });
    };

    const head = [
        { title: 'ID', property: 'IDCargoManifest', visible: true },
        { title: 'Oficina', property: 'OfficeName', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'ID Vuelo', property: 'IDFlight', visible: true },
        { title: 'Número de Vuelo', property: 'FlightName', visible: true },
        { title: 'Aeronave', property: 'AirCraft', visible: true },
        { title: 'Orígen', property: 'TransportDestinationOrigin', visible: true },
        { title: 'Destino', property: 'TransportDestinationDestinity', visible: true },
        { title: 'Observaciones', property: 'Description', visible: true },
        { title: 'Peso (KG)', property: 'WeightKg', visible: true },
        { title: 'Fecha de Creación', property: 'Since', visible: true },
    ];

    return (
        <>
            <label>{label ?? "Manifiestos de Carga"}</label>
            <span className='form-control cursor ifmodal' onClick={() => modal.open()}>{text.trim() ? text : "Seleccione un Manifiesto de Carga"}</span>

            <Modal modal={modal.modal} updateModal={modal.setModal}>
                <div className="row">
                    <div className="col-md-6">
                        <SelectCargoManifest idSelector={filter.State} onChange={(e) => { setFilter({ ...filter, State: e }) }} label="Estado" />
                    </div>
                    <div className="col-md-6">
                        <TransportDestinationEditor idSelector={filter.IDTransportDestinationOrigin} onChange={(e) => { setFilter({ ...filter, IDTransportDestinationOrigin: e }) }} returnType="ID" />
                    </div>
                    <div className="col-md-6">
                        <TransportDestinationEditor label="Destino" idSelector={filter.IDTransportDestinationDestinity} onChange={(e) => { setFilter({ ...filter, IDTransportDestinationDestinity: e }) }} returnType="ID" />
                    </div>
                    <div className="col-md-6">
                        <label>Búsqueda por Texto</label>
                        <input type="text" className="form-control" value={filter.regexStr} onChange={(e) => { setFilter({ ...filter, regexStr: e.target.value }) }} />
                    </div>
                    <div className="col-md-6 mt-4 p-2">
                        <BasicButton icon="ri-search-line" eventClick={getLista}>Buscar</BasicButton>
                    </div>
                    <div className="col-md-12">
                        <BasicTable head={head} body={lista} rowSet={(e) => { setValue(e.IDCargoManifest); }} records={paginador} />
                    </div>
                </div>

            </Modal>
        </>
    )
}